import Vue from 'vue'
import _ from 'lodash'
import store from '../store/store'

Vue.prototype._ = _
Vue.prototype.p = module => store.getters[`user/auth`](module)

Vue.prototype.$permission = function(value) {
  return store.getters[`user/auth`](value)
}

export default {}
